import { forEach } from 'lodash'

import { batchOpacityRevealAnimation } from './shared'
import { Animation } from '@/types'

export const logoWallRevealAnimation = ({ context, reverse }: Animation) => {
  const logo = context.selector?.('[data-motion-logo]')

  let logoBatchAnimation: ScrollTrigger[]
  if (logo.length > 0) {
    logoBatchAnimation = batchOpacityRevealAnimation({
      targets: logo,
      reverse,
      stagger: {
        amount: 0.12
      }
    })
  }

  return () => {
    forEach(logoBatchAnimation || [], (animation) => animation.kill())
  }
}
